import type { FaireProductEntity } from "../../entity_types/product";

export const p_5c5vcuv23p: FaireProductEntity = {
  token: "p_5c5vcuv23p",
  type: "product",
  name: "Single Deck Playing Cards - Specimens of the Sea",
  brandToken: "b_u89gdyfh23",
  brandName: "Roomytown Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/3e9f42b9f3f6084428ebe5345b75713825cd7cf36d61d40762eda2010937812d.jpeg",
  galleryImageUrls: [],
  priceDollars: 8,
  description:
    "Bring a little curiosity and charm to your card games with our Specimens of the Sea playing cards, thoughtfully designed by the Roomytown team in Bath, UK. This single deck includes 52 standard cards plus 2 jokers, each featuring detailed illustrations of sea specimens sourced from 18th-century natural history books. Inspired by the wonder of early curiosity cabinets, every card showcases artwork originally created by European naturalists who documented the ocean’s most intriguing creatures.\n\nThe back of each playing card is finished with a delicate lace motif set against a soft blue background—elegant, timeless, and distinctly Roomytown. Housed in a premium pull-drawer box, this unique deck makes a standout gift for ocean lovers, design enthusiasts, and card-game fans alike. Ideal for family games, hosting, or adding to your coffee-table collection, it brings a touch of maritime magic to every shuffle.",
  tags: [],
  msrpDollars: 17.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:40:39.334Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
